export const DEFAULT_VALUES_SXF_RECOMMENDED_PRODUCTS: Record<string, any> = {
  productSettings: {
    backgroundFplIds: [{ backgroundFplId: 14407 }],
    maxItemCount: 12,
    label: "These are the things we think you'll love",
    productSource: 'homepage_recommended-for-you',
    header: 'Recommended For You',
  },
  gridOptions: {
    sideNav: {
      showHeader: true,
    },
    elementsToHide: {
      colorsAvailable: true,
      flags: false,
      overlay: false,
      price: false,
      promo: false,
      reviewStars: true,
      wishlist: true,
    },
  },
  carouselOptions: {
    arrows: true,
    dots: false,
    autoplay: false,
    arrowsOffset: 8,
  },
  isCarousel: true,
  devDefined: {
    quizMap: {
      is_interested_in_bras: { backgroundCategoryIds: [1124] },
      is_interested_in_undies: { backgroundCategoryIds: [1125] },
      is_interested_in_boxers: { backgroundCategoryIds: [1973, 1972] },
      is_interested_in_bralettes: { backgroundCategoryIds: [1579] },
      is_interested_in_sleepwear: { backgroundCategoryIds: [1127, 2123, 2130] },
      is_interested_in_lingerie: { backgroundCategoryIds: [1126] },
      is_interested_in_sport: { backgroundCategoryIds: [1975] },
    },
  },
};
